var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "What We Do",
      "tabActive": "Overview",
      "bg": "/images/sub/visual/sv4.png"
    }
  }), _c('section', {
    staticClass: "sub-section--first sub-section--last"
  }, [_c('v-container', [_c('h2', {
    staticClass: "page-tit"
  }, [_vm._v(" Overview ")]), _c('overview', {
    attrs: {
      "src": "/images/sub/wwd/overview/overview-img1.png",
      "icon": "/images/sub/wwd/overview/overview-icon1.png",
      "iconWidth": "67",
      "num": "01",
      "tit": "Customer Service"
    }
  }, [_vm._v(" Based on the consultation, we are presenting the optimal way to manufacture the desired product "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" by reflecting the customer’s ideas ")]), _c('overview', {
    attrs: {
      "className": "reverse",
      "src": "/images/sub/wwd/overview/overview-img2.png",
      "icon": "/images/sub/wwd/overview/overview-icon2.png",
      "iconWidth": "55",
      "num": "02",
      "tit": "Design and Material Selection"
    }
  }, [_vm._v(" It is possible to mass-produce products through a customizing process such as design and material selection "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" that understands the product structure characteristics based on the experience of many semiconductor components. ")]), _c('overview', {
    attrs: {
      "src": "/images/sub/wwd/overview/overview-img3.png",
      "icon": "/images/sub/wwd/overview/overview-icon3.png",
      "iconWidth": "54",
      "num": "03",
      "tit": "Consultation"
    }
  }, [_vm._v(" We have a variety of precision processing facilities to provide high-quality products to our customers. ")]), _c('overview', {
    attrs: {
      "className": "reverse",
      "src": "/images/sub/wwd/overview/overview-img4.png",
      "icon": "/images/sub/wwd/overview/overview-icon4.png",
      "iconWidth": "54",
      "num": "04",
      "tit": "Polishing"
    }
  }, [_vm._v(" Through precision abrasive processing, we produce the optimal product desired by our customers. "), _c('br'), _vm._v(" (Polishing process specialized for CMP process) ")]), _c('overview', {
    attrs: {
      "src": "/images/sub/wwd/overview/overview-img5.png",
      "icon": "/images/sub/wwd/overview/overview-icon5.png",
      "iconWidth": "54",
      "num": "05",
      "tit": "Quality Inspection"
    }
  }, [_vm._v(" We are equipped with the best measuring instruments necessary for quality control, such as 3D measuring instruments, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" precision roughness measuring instruments and microscopes are strictly conducting data analysis and product management through SPC. ")]), _c('overview', {
    attrs: {
      "className": "reverse",
      "src": "/images/sub/wwd/overview/overview-img6.png",
      "icon": "/images/sub/wwd/overview/overview-icon6.png",
      "iconWidth": "55",
      "num": "06",
      "tit": "Application Test"
    }
  }, [_vm._v(" After the first verification test using internal and external facilities, the customer's internal test is carried out. ")]), _c('overview', {
    attrs: {
      "src": "/images/sub/wwd/overview/overview-img7.png",
      "icon": "/images/sub/wwd/overview/overview-icon7.png",
      "iconWidth": "54",
      "num": "07",
      "tit": "Mass Production"
    }
  }, [_vm._v(" We do our best for the quality and delivery time of the products our customers require. ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }